import * as React from 'react'
import slugify from 'react-slugify';

export const Textblock = ({ id, title, text }) => {
	return (
		<div className="c-content-block" id={title ? slugify(title) : undefined}>
			{title.length > 0 && <h2>{title}</h2>}
			<div dangerouslySetInnerHTML={{ __html: text }} />
		</div>
	)
}
